import './index.scss';
import { useTranslation } from 'react-i18next';
import ChangeGymHeader from '../ChangeGymHeader';
import ChangeGymContent from '../ChangeGymContent';
import { useOpenOldModal } from '../../../../store/modal/modalHooks';
import { ModalComponentEnum } from '../../../../store/modal/modalTypes';
import { GymResource } from '../../../../store/gym-management/GymTypes';
import CardComponent from '../../../cards-components/cards/CardComponent';

interface ChangeGymCardProps {
  room: GymResource;
}

const ChangeGymCard = (props: ChangeGymCardProps) => {
  const { t } = useTranslation();
  const openModal = useOpenOldModal();

  const onClickGymRoom = () => {
    openModal(ModalComponentEnum.BOOK_GYM_ROOM_MODAL, undefined, {
      id: props.room.id,
    });
  };

  return (
    <div className="change-gym-card" onClick={onClickGymRoom}>
      <CardComponent
        header={
          <ChangeGymHeader
            image={
              props.room.image ||
              'https://cdn.shopify.com/s/files/1/1367/5207/files/Desktop_1_843bbe99-9677-45b7-ac63-17de8d16421e_1900x.jpg?v=1650538814'
            }
          />
        }
        body={<ChangeGymContent room={props.room} />}
      />
    </div>
  );
};

export default ChangeGymCard;
